function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#111",
  d: "M236.686111,20.3722222 C238.794444,20.3722222 240.780556,19.7 242.338889,18.5388889 L246.8,23 L249,20.8 L244.538889,16.3388889 C245.7,14.75 246.372222,12.7944444 246.372222,10.6861111 C246.372222,5.33888889 242.033333,1 236.686111,1 C231.338889,1 227,5.33888889 227,10.6861111 C227,16.0333333 231.338889,20.3722222 236.686111,20.3722222 Z M236.5,4 C240.097674,4 243,6.90232558 243,10.5 C243,14.0976744 240.097674,17 236.5,17 C232.902326,17 230,14.0976744 230,10.5 C230,6.90232558 232.902326,4 236.5,4 Z",
  transform: "translate(-227 -1)"
});

function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _ref);
}

export default __webpack_public_path__ + "media/images/icon_search-dc98eb9e.svg";
export { SvgIconSearch as ReactComponent };